exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-outline-primary[data-v-4ed44aca]{background-color:transparent!important;color:var(--primary)}", ""]);

// exports
